import { render } from "./ModuleTabbarAllTab.vue?vue&type=template&id=7f868884&scoped=true"
import script from "./ModuleTabbarAllTab.vue?vue&type=script&lang=js"
export * from "./ModuleTabbarAllTab.vue?vue&type=script&lang=js"

import "./ModuleTabbarAllTab.vue?vue&type=style&index=0&id=7f868884&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f868884"]])

export default __exports__